"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.Token = void 0;

var lodash_1 = __importDefault(require("lodash"));

var uuid_1 = require("uuid");

var Term_1 = require("./Term");

var Token = function () {
  function Token(token, value, opts, index) {
    if (opts === void 0) {
      opts = {};
    }

    if (index === void 0) {
      index = -1;
    }

    this.id = uuid_1.v4();
    this.data = {};
    this.evaluated = false;

    if (token instanceof Term_1.Term) {
      this.token = token.token;
      this.value = value || token.value;
      this.opts = token.opts;
      this.index = index;
      return;
    }

    if (lodash_1["default"].isObject(token)) {
      this.token = token.token;
      this.value = token.value;
      this.opts = token.opts ? token.opts : {};
      this.index = token.index;
      return;
    }

    this.token = token;
    this.value = value;
    this.opts = opts ? opts : {};
    this.index = index;
  }

  Token.fromJson = function (tokenJson) {
    return new Token(tokenJson.token, tokenJson.value, tokenJson.opts, tokenJson.index);
  };

  Token.mash = function (tokens) {
    return tokens.filter(function (t) {
      return t instanceof Token;
    }).map(function (t) {
      return t.value;
    }).join(' ');
  };

  Token.prototype.toJson = function () {
    var json = {
      token: this.token,
      index: this.index,
      value: this.value
    };
    return json;
  };

  return Token;
}();

exports.Token = Token;